export default {
  api: {
    RECEITA_DESKTOP: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/receitas/desktop',
    RECEITA_MOBILE: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/receitas/mobile',

    DEMONSTRACOES_CONTABEIS: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/arquivos/demonstracoes_cpt',

    SINGLE_RECEITAS: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/receitas',

    CATEGORIAS_ATOS_OFICIAIS: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/atosoficias/categories',
    ARQUIVOS_ATOS_OFICIAIS: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/atosoficias/arquivos',

    FILIAIS: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/filiais',
    ANOS: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/anos',
    MESES: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/meses',

    COLABORADORES: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/colaboradores/categories',

    ORCAMENTOS: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/arquivos/orcamentos_cpt',

    DESPESAS_POR_MES: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/despesas/meses',
    SINGLE_DESPESAS: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/despesas/descricao',
    CATEGORIAS_DE_DESPESAS: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/despesas/categorias',
    DESPESAS: 'https://transparencia-api.oab-ro.org.br/api/wp-json/transparencia/despesas',
  }
};
